import styled from 'styled-components'
import { CircularProgress, Fade } from '@mui/material'

interface Props {
  visible?: boolean
}

const loaderSize = 64

const OverlayWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${(props) =>
    props.theme?.palette?.mode === 'light' ? 'rgba(255,255,255,0.8)' : 'rgba(68,68,68,0.8)'};
  z-index: 10000;

  & .MuiCircularProgress-root {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -${loaderSize / 2}px;
    margin-top: -${loaderSize / 2}px;
  }
`

export default function OverlayLoader({ visible }: Props): JSX.Element {
  return (
    <Fade in={visible} unmountOnExit={true}>
      <OverlayWrapper>
        <CircularProgress size={loaderSize} thickness={2.6} style={{}} />
      </OverlayWrapper>
    </Fade>
  )
}
